import { render, staticRenderFns } from "./DceBeforeYouContinue.vue?vue&type=template&id=494f48ae&scoped=true&"
import script from "./DceBeforeYouContinue.vue?vue&type=script&lang=js&"
export * from "./DceBeforeYouContinue.vue?vue&type=script&lang=js&"
import style0 from "./DceBeforeYouContinue.vue?vue&type=style&index=0&id=494f48ae&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494f48ae",
  null
  
)

export default component.exports